import { useTranslation } from "react-i18next";
import "./CashlessModal.scss";

export function DeleteConfirmationModal({ show, onHide, onConfirm, cardToDelete, loading = false }) {
  const { t } = useTranslation("cashless");

  if (!show) return null;

  return (
    <div className="modal fade show d-block cashless-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {t("confirmDelete", "Confirm Delete")}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onHide}
              disabled={loading}
            />
          </div>

          <div className="modal-body">
            <p className="confirmation-text">
              {t("confirmDeleteMessage", "Are you sure you want to delete this card?")}
            </p>
            {cardToDelete && (
              <div className="card-info">
                <div className="card-info-row">
                  <span className="card-info-label">
                    {t("cardId", "Card ID")}:
                  </span>
                  <code className="card-info-value card-id">{cardToDelete.id}</code>
                </div>
                <div className="card-info-row">
                  <span className="card-info-label">
                    {t("balance", "Balance")}:
                  </span>
                  <span className="card-info-value">€{cardToDelete.balance?.toFixed(2) || '0.00'}</span>
                </div>
              </div>
            )}
            <p className="warning-text">
              {t("deleteWarning", "This action cannot be undone.")}
            </p>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-cancel"
              onClick={onHide}
              disabled={loading}
            >
              {t("cancel", "Cancel")}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? t("deleting", "Deleting...") : t("delete", "Delete")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmationModal;